import {store} from '@/store';
import client from '@/store/client';

store.registerModule('client', client);

export default store;
